export const createHash = () => ({
  update() {
    return this;
  },
  digest() {
    return "";
  },
});

export const randomUUID = () => "00000000-0000-4000-8000-000000000000";

export default { createHash, randomUUID };
